
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { Router } from '@angular/router';
import { AppKeycloakService } from './services/keycloak.service';

@Component({
  selector: 'ngx-app',
  // template: '<router-outlet></router-outlet>',
  templateUrl:'./app.component.html'
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService,
    private router: Router, private ks:AppKeycloakService
  ) {
    // history.replaceState({}, '')
    // Clear state of the CURRENT history entry
    history.replaceState(null, '', location.href);
  }



  ngOnInit(): void {
     // Redirect to login page on app initialization
    //  this.router.navigate(['/login']);
    // this.ks.spinLoading('none')
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }
}
